<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">应急任务管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>应急计划管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="title">应急计划管理</div>
      <div class="select-box">
        <div class="select-label">日历月份</div>
        <el-date-picker
          value-format="yyyy-MM"
          v-model="year"
          type="month"
          placeholder="选择月份"
          @change="yearChange"
        >
        </el-date-picker>
      </div>
      <div class="rl-box">
        <div class="left">
          <el-calendar :first-day-of-week="7" v-model="value">
            <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
            <div
              @click.stop="setSchedule(data.day)"
              slot="dateCell"
              class="calendarday"
              slot-scope="{ date, data }"
              :class="{ 'selected-cla': data.isSelected }"
            >
              <div class="day" :class="{ today: getCurrentDate(data.day) }">
                {{ handleDay(data.day) }}
              </div>
              <div class="status" v-if="data.type == 'current-month'">
                <span
                  v-for="(item, index) in isHoliday(data.day)"
                  :key="index"
                  :class="{ xiu: item == '防汛应急' }"
                  >{{ item }}</span
                >
              </div>
            </div>
          </el-calendar>
        </div>
        <div class="right">
          <div style="display: flex;align-items: center;" class="title">
            <img
              style="height: 36px;margin-right: 8px;"
              src="@/assets/image/jhrl.png"
              alt=""
            />
            <span>{{ value }}</span>
          </div>
          <div v-if="editType == 1 || isShow">
            <div
              style="margin-top: 32px;margin-bottom: 16px;font-family: MiSans, MiSans;
                font-weight: 400;
                font-size: 16px;
                color: #494C4F;"
            >
              应急类型
            </div>
            <el-checkbox-group v-model="formData.emergencyTypes">
              <el-checkbox label="防风应急"></el-checkbox>
              <el-checkbox label="防汛应急"></el-checkbox>
            </el-checkbox-group>
            <div
              style="margin-top: 32px;margin-bottom: 16px;font-family: MiSans, MiSans;
                font-weight: 400;
                font-size: 16px;
                color: #494C4F;"
            >
              应急等级设置
            </div>
            <el-radio-group v-model="formData.emergencyLevel">
              <el-radio label="1">Ⅰ</el-radio>
              <el-radio label="2">Ⅱ</el-radio>
              <el-radio label="3">Ⅲ</el-radio>
              <el-radio label="4">Ⅳ</el-radio>
            </el-radio-group>
            <div
              style="margin-top: 32px;margin-bottom: 16px;font-family: MiSans, MiSans;
                font-weight: 400;
                font-size: 16px;
                color: #494C4F;"
            >
              常态任务启停状态
            </div>
            <el-switch
              v-model="formData.otherState"
              active-value="是"
              inactive-value="否"
            >
            </el-switch>
            <div
              v-if="
                formData.emergencyLevel == 1 || formData.emergencyLevel == 2
              "
              style="margin-top: 32px;margin-bottom: 16px;font-family: MiSans, MiSans;
                font-weight: 400;
                font-size: 16px;
                color: #494C4F;"
            >
              短信验证
            </div>
            <div
              style="display: flex;"
              v-if="
                formData.emergencyLevel == 1 || formData.emergencyLevel == 2
              "
            >
              <el-input
                style="width: 195px;margin-right: 12px;"
                v-model="formData.verificationCode"
                placeholder="请输入短信验证码"
              ></el-input>
              <el-button
                @click="verificationCodeApiFun"
                :disabled="countdown > 0"
                style="border-radius: 4px;
                       height: 40px;
                       line-height: 1;
                       border: 1px solid #0090FF;font-size: 16px;
                       color: #0090FF;"
                >{{ countdown > 0 ? countdown + "s" : "获取验证码" }}</el-button
              >
            </div>
            <el-button
              @click="createEmergencyPlanFun"
              style="border-radius: 4px;
              margin-top: 24px;
              width: 100%;
              height: 40px;
              line-height: 1;font-size: 16px;
              color: #FFFFFF;background: linear-gradient( 180deg, #2E81FF 0%, #46B0FD 100%);"
              >{{ editType != 2 ? "启动应急模式" : "提交" }}</el-button
            >
            <el-button
              v-if="editType != 1"
              @click="isShow = false"
              style="border-radius: 4px;
              margin-top: 24px;
              width: 100%;
              height: 40px;
              line-height: 1;font-size: 16px;
              margin-left: 0;
              color: #494C4F;"
              >取 消</el-button
            >
          </div>
          <div v-if="editType != 1 && !isShow">
            <div
              class="time-box"
              :style="{
                'max-height':
                  editType == 2 ? '540px' : editType == 3 ? '600px' : '660px'
              }"
            >
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in activities"
                  :class="{
                    'timeline-item-add': activity.operType == '新增',
                    'timeline-item-stop': activity.operType == '停止'
                  }"
                  :key="index"
                  :color="
                    activity.operType == '新增'
                      ? 'rgba(12, 206, 179, 0.1)'
                      : activity.operType == '停止'
                      ? 'rgba(217, 56, 95, 0.1)'
                      : 'rgba(0, 144, 255, 0.1)'
                  "
                >
                  <div class="time">
                    <span> {{ activity.operTime }}</span>
                    <div
                      class="type-box"
                      :class="{
                        'type-box1': activity.operType == '新增',
                        'type-box2': activity.operType == '停止'
                      }"
                    >
                      {{ activity.operType }}
                    </div>
                  </div>
                  <div class="content">
                    <div class="content-top">
                      <div class="content-top-item">
                        <span>应急类型</span>
                        <span
                          class="type-span"
                          :class="{ xiu: item == '防汛应急' }"
                          v-for="(item, index) in activity.operResultJson1
                            .emergencyTypes1"
                          >{{ item }}</span
                        >
                      </div>
                      <div class="content-top-item">
                        <span>应急等级设置</span>
                        <span>{{
                          levelsMappingData[
                            Number(activity.operResultJson1.emergencyLevel) - 1
                          ]
                        }}</span>
                      </div>
                      <div class="content-top-item">
                        <span>常态任务启停状态</span>
                        <span>{{
                          activity.operResultJson1.otherState == "是"
                            ? "启用"
                            : "关闭"
                        }}</span>
                      </div>
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
            <el-button
              v-if="editType == 2"
              @click="closeYj"
              style="border-radius: 4px;
              margin-top: 24px;
              width: 100%;
              height: 40px;
              line-height: 1;font-size: 16px;
              color: #494C4F;"
              >关闭应急模式</el-button
            >
            <el-button
              v-if="editType != 4"
              @click="isShow = true"
              style="border-radius: 4px;
              margin-top: 24px;
              width: 100%;
              height: 40px;
              margin-left: 0;
              line-height: 1;font-size: 16px;
              color: #FFFFFF;background: linear-gradient( 180deg, #2E81FF 0%, #46B0FD 100%);"
              >{{ editType == 2 ? "编 辑" : "开启应急模式" }}</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="关闭应急模式"
      :visible.sync="dialogVisible"
      width="480px"
      :before-close="handleClose"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div class="container-dialog">
        <el-form :model="formInline" ref="form">
          <el-form-item label="验证码" prop="typeName">
            <el-input
              style="width: 195px;margin-right: 12px;"
              v-model="formInline.verificationCode"
              placeholder="请输入验证码"
            ></el-input>
            <el-button
              @click="verificationCodeApiFun"
              :disabled="countdown > 0"
              style="border-radius: 4px;
              height: 40px;
              line-height: 1;
              border: 1px solid #0090FF;font-size: 16px;
              color: #0090FF;"
              >{{ countdown > 0 ? countdown + "s" : "获取验证码" }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="stopEmergencyPlanFun"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  fillMonthList,
  listByPlanIds,
  createEmergencyPlan,
  modifyEmergencyPlan,
  stopEmergencyPlan
} from "@/api/crashInfo.js";
import { verificationCodeApi } from "@/api/systemManagement.js";
import moment from "moment";
export default {
  data() {
    return {
      year: moment(new Date()).format("YYYY-MM"),
      value: moment(new Date()).format("YYYY-MM-DD"),
      scheduleList: [],
      checkList: [],
      formData: {
        emergencyLevel: "",
        emergencyTypes: [],
        otherState: "是",
        verificationCode: ""
      },
      editType: 1,
      activities: [],
      isShow: false,
      levelsMappingData: ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ"],
      dialogVisible: false,
      formInline: {
        verificationCode: ""
      },
      countdown: 0, // 初始倒计时秒数
      timer: null
    };
  },
  mounted() {
    this.fillMonthListFun();
  },
  beforeUnmount() {
    this.clearCountdown(); // 页面卸载前清除倒计时
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.formInline.verificationCode = "";
    },
    yearChange(value) {
      this.value = moment(value).format("YYYY-MM-DD");
      this.fillMonthListFun();
    },
    // 获取当前日期
    getCurrentDate(date) {
      // 判断是否为今天
      const today = moment().format("YYYY-MM-DD");
      const currentDate = moment(date).format("YYYY-MM-DD");
      if (today === currentDate) {
        return true;
      }
      return false;
    },
    // 设置排班
    setSchedule(date) {
      this.value = moment(date).format("YYYY-MM-DD");
      this.getKeyList();
    },
    // 应急类型回显
    isHoliday(date) {
      // 使用 Map 优化查找性能并避免重复
      const emergencyTypesMap = new Map();

      // 使用 try-catch 包裹 JSON.parse 以增强安全性
      this.scheduleList.forEach(item => {
        const formattedDate = moment(date).format("YYYY-MM-DD");
        if (item.timeStr === formattedDate) {
          if (item.planOperRecords && item.planOperRecords.length) {
            item.planOperRecords.forEach(itm => {
              if (itm.operResultJson && itm.operResultJson.length) {
                try {
                  // 安全地解析 JSON 字符串
                  const parsedJson = JSON.parse(itm.operResultJson);
                  // 检查是否包含 emergencyTypes 字段
                  if (parsedJson.emergencyTypes) {
                    // 将 emergencyTypes 分割并添加到 Map 中，自动去重
                    parsedJson.emergencyTypes.split(",").forEach(type => {
                      emergencyTypesMap.set(type.trim(), true);
                    });
                  }
                } catch (error) {
                  console.error("Error parsing JSON:", error);
                  // 可以选择在此处处理错误，例如跳过该项或记录错误
                }
              }
            });
          }
        }
      });

      // 从 Map 中提取键形成最终的数组，并保持原始顺序
      return Array.from(emergencyTypesMap.keys());
    },
    // 处理日期
    handleDay(date) {
      const day = moment(date).date();
      return day;
    },
    getKeyList() {
      const keyList = new Set();
      this.scheduleList.forEach(item => {
        if (item.timeStr == moment(this.value).format("YYYY-MM-DD")) {
          item.planOperRecords.forEach(({ ghEmergencyPlanId }) => {
            keyList.add(ghEmergencyPlanId);
          });
        }
      });
      this.listByPlanIdsFun(keyList);
    },
    async listByPlanIdsFun(keyList) {
      const res = await listByPlanIds({
        keyList: keyList
      });
      this.isShow = false;
      this.activities = res.data.data || [];
      this.activities.forEach(item => {
        if (item.operResultJson && item.operResultJson.length) {
          item.operResultJson1 = JSON.parse(item.operResultJson);
          item.operResultJson1.emergencyTypes1 = item.operResultJson1
            .emergencyTypes
            ? item.operResultJson1.emergencyTypes.split(",")
            : [];
        }
      });
      let flag = this.getCurrentDate(this.value);
      this.formData = {
        emergencyLevel: "",
        emergencyTypes: [],
        otherState: "是",
        verificationCode: ""
      };
      if (flag) {
        this.editType = 1;
        if (res.data.data && res.data.data.length) {
          const firstItem = res.data.data[0];
          this.editType = firstItem.operType === "停止" ? 3 : 2;
          if (this.editType === 2) {
            const operResultJson = this.activities[0].operResultJson1;
            this.formData = {
              emergencyLevel: operResultJson.emergencyLevel,
              emergencyTypes: operResultJson.emergencyTypes1,
              otherState: operResultJson.otherState,
              verificationCode: operResultJson.verificationCode,
              id: operResultJson.id
            };
          }
        }
      } else {
        this.editType = 4;
      }
    },
    closeYj() {
      if (
        this.formData.emergencyLevel == "1" ||
        this.formData.emergencyLevel == "2"
      ) {
        this.dialogVisible = true;
      } else {
        this.stopEmergencyPlanFun();
      }
    },
    async fillMonthListFun() {
      const res = await fillMonthList({
        timeStr: this.year
      });
      this.scheduleList = res.data.data;
      this.getKeyList();
    },
    //获取短信验证码
    async verificationCodeApiFun() {
      const res = await verificationCodeApi();
      if (res.data.code == 200) {
        this.$message({
          message: "发送成功",
          type: "success"
        });
        this.countdown = 60;
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--; // 每秒减1
          } else {
            this.clearCountdown(); // 倒计时结束，清除定时器
          }
        }, 1000);
      }
    },
    clearCountdown() {
      clearInterval(this.timer); // 清除定时器
    },

    async createEmergencyPlanFun() {
      if (!this.formData.emergencyTypes.length) {
        this.$message({
          message: "请选择应急类型",
          type: "warning"
        });
        return;
      }
      if (!this.formData.emergencyLevel) {
        this.$message({
          message: "请选择应急等级设置",
          type: "warning"
        });
        return;
      }
      if (!this.formData.otherState) {
        this.$message({
          message: "请选择常态任务启停状态",
          type: "warning"
        });
        return;
      }
      if (
        (this.formData.emergencyLevel == 1 ||
          this.formData.emergencyLevel == 2) &&
        !this.formData.verificationCode
      ) {
        this.$message({
          message: "请输入短信验证码",
          type: "warning"
        });
        return;
      }
      let res = null;
      if (this.editType != 2) {
        res = await createEmergencyPlan({
          emergencyLevel: this.formData.emergencyLevel,
          emergencyTypes: this.formData.emergencyTypes.toString(),
          otherState: this.formData.otherState,
          verificationCode: this.formData.verificationCode
        });
      } else {
        res = await modifyEmergencyPlan({
          emergencyLevel: this.formData.emergencyLevel,
          emergencyTypes: this.formData.emergencyTypes.toString(),
          otherState: this.formData.otherState,
          verificationCode: this.formData.verificationCode,
          id: this.formData.id
        });
      }
      if (res.data.code == 200) {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.fillMonthListFun();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    async stopEmergencyPlanFun() {
      if (
        !this.formInline.verificationCode &&
        (this.formData.emergencyLevel == "1" ||
          this.formData.emergencyLevel == "2")
      ) {
        this.$message({
          message: `请输入验证码`,
          type: "warning"
        });
        return;
      }
      const res = await stopEmergencyPlan({
        id: this.formData.id,
        verificationCode: this.formInline.verificationCode
      });

      if (res.data.code == 200) {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.handleClose();
        this.getKeyList();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.year = moment(newValue).format("YYYY-MM");
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
.box-father,
.box-father .section {
  height: auto;
}
.title {
  font-family: MiSans, MiSans;
  font-weight: 700;
  font-size: 20px;
  color: #494c4f;
}

.box-father {
  padding-bottom: 24px;
}
.select-box {
  display: flex;
  align-items: center;
  margin-top: 24px;
  .select-label {
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 16px;
    color: #494c4f;
    margin-right: 16px;
  }
}
.rl-box {
  width: 100%;
  height: calc(100% - 114px);
  display: flex;
  margin-top: 20px;
  .left {
    width: calc(100% - 369px);
    height: 100%;
    /deep/.el-calendar__body {
      padding: 0 16px 0 0;
    }
    /deep/ .el-calendar-table {
      thead {
        th::before {
          content: "周";
        }

        th {
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 18px;
          color: #494c4f;
          text-align: center;
          background: #fff;
          border: 1px solid #eeeeee;
        }
      }
    }

    /deep/.el-calendar__header {
      display: none;
    }
    /deep/ .el-calendar-table .el-calendar-day {
      height: 120px;
      padding: 12px 0;
    }

    // 当前月
    /deep/.el-calendar-table__row .current .el-calendar-day {
      padding: 0px;
    }

    // 工作日
    /deep/.el-calendar-table__row .current .el-calendar-day .calendarday {
      padding: 12px 0;
      width: 100%;
      height: 100%;
    }
    // 当前选中
    /deep/.el-calendar-table__row .current .el-calendar-day .selected-cla,
    /deep/.el-calendar-table .el-calendar-day:hover {
      border: 2px solid rgba(0, 144, 255, 0.3);
      .day {
        font-family: MiSans, MiSans;
        font-weight: 500;
        font-size: 24px;
        color: #0090ff !important;
        margin-top: 28px;
      }
    }
    /deep/.el-calendar-table td.is-selected,
    /deep/.el-calendar-table .el-calendar-day:hover {
      background: none;
    }

    .day {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 18px;
      color: #494c4f;
      text-align: center;
      margin-top: 36px;
    }
    .status {
      text-align: center;
      margin-top: 8px;
      span {
        display: inline-block;
        background: rgba(255, 139, 70, 0.1);
        border-radius: 2px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 14px;
        color: #ff8b46;
        padding: 2px 6px;
      }
      .xiu {
        background: rgba(0, 144, 255, 0.1);
        color: #0090ff;
        margin-left: 8px;
      }
    }
    /deep/.el-calendar-table__row .prev .el-calendar-day,
    /deep/.el-calendar-table__row .next .el-calendar-day {
      background: #f5f6f7;
      .day {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #92979c;
        margin-top: 36px;
      }
    }

    .today {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 24px;
      color: #0090ff !important;
      margin-top: 28px;
    }
  }
  .right {
    width: 369px;
    height: 778px;
    padding: 32px 18px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    position: relative;
    background: url("~@/assets/image/yjjh.png") right top no-repeat !important;
    background-size: 160px 240px !important;
    .footer {
      position: absolute;
      bottom: 12px;
      right: 16px;
    }
  }
  .right1 {
    background: linear-gradient(
      180deg,
      #eef8ff 0%,
      rgba(255, 255, 255, 0) 100%
    ) !important;
    .top {
      height: 240px;
      width: 100%;
      background: url("~@/assets/image/yjjh.png") right top no-repeat !important;
      background-size: 160px 240px !important;
    }
    .empoy-box {
      margin-top: 60px;
      text-align: center;
      img {
        width: 160px;
        height: 126px;
      }
      .text-box {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 14px;
        color: #494c4f;
        margin-top: 8px;
      }
      .text-box1 {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 13px;
        color: #92979c;
      }
    }
  }
}
/deep/.el-tag.el-tag--info {
  margin-top: 16px;
  margin-right: 16px;
}
.time-box {
  max-height: 540px;
  overflow: auto;
  margin-top: 24px;
}
/deep/.el-timeline {
  padding: 0;
  .time {
    display: flex;
    align-items: center;
    font-family: MiSans, MiSans;
    font-weight: 700;
    font-size: 16px;
    color: #494c4f;
    .type-box {
      padding: 3px 9px;
      color: #0090ff;
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      background: rgba(0, 144, 255, 0.1);
      margin-left: 9px;
    }
  }
  .content-top {
    padding: 16px 24px;
    background: #f9f9ff;
    border-radius: 8px;
    margin-top: 6px;
    .content-top-item {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #92979c;
      margin-bottom: 8px;
      i {
        margin-right: 12px;
      }
      span {
        margin-right: 16px;
      }
      .type-span {
        display: inline-block;
        background: rgba(255, 139, 70, 0.1);
        border-radius: 2px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 14px;
        color: #ff8b46;
        padding: 2px 6px;
        margin-right: 4px;
      }
      .type-span.xiu {
        background: rgba(0, 144, 255, 0.1);
        color: #0090ff;
        margin-left: 4px;
      }
    }
    .content-top-item:last-child {
      margin-bottom: 0;
    }
  }
}
/deep/.el-timeline-item__node--large {
  width: 18px;
  height: 18px;
  line-height: 18px;
  padding-top: 2px;
}
/deep/.el-timeline-item__tail {
  left: 8px;
  top: 18px;
  height: calc(100% - 18px);
  border-left: 1px dashed #b9c0d7;
}
/deep/.el-timeline-item__node--normal {
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.el-timeline-item__node--normal::after {
  content: "";
  width: 9px;
  height: 9px;
  background: #0090ff;
  border-radius: 50%;
}
.timeline-item-add {
  .time {
    .type-box {
      background: rgba(12, 206, 179, 0.1);
      color: #00ac94;
    }
  }
  /deep/.el-timeline-item__node--normal::after {
    content: "";
    width: 9px;
    height: 9px;
    background: #00ac94;
    border-radius: 50%;
  }
}
.timeline-item-stop {
  .time {
    .type-box {
      background: rgba(217, 56, 95, 0.1);
      color: #d9385f;
    }
  }
  /deep/.el-timeline-item__node--normal::after {
    content: "";
    width: 9px;
    height: 9px;
    background: #d9385f;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/crashInfo/crashPlan/index.vue